import * as React from 'react';
import { CustomButton, ButtonType, ModalBody, HiddenInput, Textarea, Modal, ModalSize, ModalFooter, CustomSubmitButton } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { GeneralDentalReferralResponseApi } from "../../../../api/GeneralDentalReferralResponseApi";
import { IGeneralDentalReferralRejectModel } from '../../../../models/IGeneralDentalReferral';

interface IGeneralDentalReferralRejectButton {
    generalDentalReferralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getGeneralDentalReferral: (id: number) => void;
}

export const GeneralDentalReferralRejectButton: React.FunctionComponent<IGeneralDentalReferralRejectButton> = ({ changeSuccessMessage, changeErrorMessage, getGeneralDentalReferral, generalDentalReferralId }) => {
    const auth = useAuth();
    const api = new GeneralDentalReferralResponseApi(auth);
    const [isRejecting, setIsRejecting] = React.useState<boolean>(false);
    const [renderForm, setRenderForm] = React.useState<boolean>(false);

    const rejectGeneralDentalReferral = (data: IGeneralDentalReferralRejectModel) => {
        setIsRejecting(true);
        api.rejectGeneralDentalReferral(data,
            () => {
                document.getElementById("close-reject-generalDental-referral-modal")?.click();
                getGeneralDentalReferral(generalDentalReferralId);
                changeSuccessMessage("Allmäntandvårdsremissen har avvisats");
            },
            (error) => {
                changeErrorMessage(error);
            },
            () => {
                setIsRejecting(false);
            })
    }

    return (
        <>
            <CustomButton buttonType={ButtonType.deleteAlt} buttonText="Avvisa" data-toggle="modal" data-target="#reject-generalDental-referral-modal" onClick={() => setRenderForm(true)} />
            <Modal header="Avvisa allmäntandvårdsremiss" id="reject-generalDental-referral-modal" modalSize={ModalSize.normal}>
                {
                    renderForm ?
                        <>
                            <ModalBody>
                                <HiddenInput name="generalDentalReferralId" value={generalDentalReferralId.toString()} />
                                <Textarea name="comment" label="Anledning" rows={5} required inlineLabel />
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-reject-generalDental-referral-modal" onClick={() => setRenderForm(false)} />
                                <CustomSubmitButton onButtonSubmit={rejectGeneralDentalReferral} isLoading={isRejecting}>Avvisa</CustomSubmitButton>
                            </ModalFooter>
                        </>
                        : null
                }                
            </Modal>
        </>
    )
}